export default __webpack_public_path__ + "static/media/articlevideo.acbf83eb.png";